<template>
    <v-container>
      <v-row justify="center">
        <v-col cols="12" md="10" lg="8">
          <v-card class="rounded-xl elevation-4">
            <v-card-title class="primary white--text">
              <v-icon large left color="white">mdi-account-edit</v-icon>
              <span class="headline font-weight-bold">Editar Técnico</span>
            </v-card-title>

            <v-divider class="mb-4"></v-divider>

            <v-card-text>
              <v-form v-model="valid" ref="form" @submit.prevent="submit">
                <v-text-field
                  v-model="username"
                  label="Login"
                  disabled
                  outlined
                  prepend-icon="mdi-account"
                  class="mb-4"
                ></v-text-field>

                <v-text-field
                  v-model="nome"
                  label="Nome completo"
                  disabled
                  outlined
                  prepend-icon="mdi-card-account-details"
                  class="mb-4"
                ></v-text-field>

                <v-text-field
                  v-model="novaSenha"
                  :append-icon="show1 ? 'mdi-eye-off' : 'mdi-eye'"
                  :type="show1 ? 'text' : 'password'"
                  label="Nova senha"
                  outlined
                  :rules="senhaRules"
                  prepend-icon="mdi-lock"
                  @click:append="show1 = !show1"
                  class="mb-4"
                ></v-text-field>

                <v-text-field
                  v-model="novaSenha1"
                  :append-icon="show2 ? 'mdi-eye-off' : 'mdi-eye'"
                  :type="show2 ? 'text' : 'password'"
                  label="Confirme a nova senha"
                  outlined
                  :rules="senha1Rules"
                  prepend-icon="mdi-lock-check"
                  @click:append="show2 = !show2"
                  class="mb-4"
                ></v-text-field>

                <v-alert
                  v-model="erroLogin"
                  color="error"
                  icon="mdi-alert-circle"
                  dense
                  outlined
                  dismissible
                  class="mb-4"
                >
                  Erro ao alterar senha!
                </v-alert>

                <v-alert
                  v-model="sucessoLogin"
                  color="success"
                  icon="mdi-check-circle"
                  dense
                  outlined
                  dismissible
                  class="mb-4"
                >
                  Senha alterada com sucesso!
                </v-alert>

                <v-card-actions class="px-0">
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary"
                    large
                    rounded
                    depressed
                    type="submit"
                    :disabled="!valid"
                    :loading="loading"
                    class="px-6"
                  >
                    <v-icon left>mdi-content-save</v-icon>
                    Salvar Alterações
                  </v-btn>

                  <v-btn
                    to="/listaTecnicosUnidade"
                    large
                    outlined
                    rounded
                    color="grey darken-1"
                    class="ml-2"
                  >
                    <v-icon left>mdi-arrow-left</v-icon>
                    Voltar
                  </v-btn>
                </v-card-actions>
              </v-form>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
import administradorUnidadeService from '../../../services/administradorUnidade.service'
import medicoService from '../../../services/medico.service'
var sha1 = require('sha1')

export default {
  name: 'EditarTecnico',
  data () {
    return {
      show1: false,
      show2: false,
      valid: false,
      loading: false,
      erroLogin: false,
      sucessoLogin: false,
      username: '',
      nome: '',
      idMedico: '',
      novaSenha: '',
      novaSenha1: '',
      senhaRules: [
        v => !!v || 'Senha é obrigatória',
        v => (v && v.length >= 6) || 'Mínimo de 6 caracteres'
      ],
      senha1Rules: [
        v => !!v || 'Confirmação de senha é obrigatória',
        v => v === this.novaSenha || 'As senhas não coincidem'
      ]
    }
  },
  mounted () {
    if (!this.$route.params.medico) {
      this.$router.push('/listaTecnicosUnidade')
      return
    }

    const { username, nome, idMedico } = this.$route.params.medico
    this.username = username
    this.nome = nome
    this.idMedico = idMedico
  },
  methods: {
    async submit () {
      if (!this.$refs.form.validate()) return

      this.loading = true
      this.erroLogin = false
      this.sucessoLogin = false

      try {
        const response = await medicoService.medico.alterarSenha({
          idMedico: this.idMedico,
          senha: sha1(this.novaSenha)
        })

        if (response.data === 'usernameExistente') {
          this.erroLogin = true
          return
        }

        if (response.data.status === 'success') {
          this.sucessoLogin = true
          setTimeout(() => {
            this.$router.push('/listaTecnicosUnidade')
          }, 1500)
        }
      } catch (error) {
        console.error('Erro ao alterar senha:', error)
        this.erroLogin = true
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.rounded-xl {
  border-radius: 16px !important;
}

.v-card__title {
  border-top-left-radius: 16px !important;
  border-top-right-radius: 16px !important;
}

.v-btn {
  letter-spacing: normal;
  text-transform: none;
}

.v-btn--disabled {
  opacity: 0.6;
}
</style>
